import createTheme from './createTheme';
var defaultTheme = createTheme();
export default defaultTheme;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/styles/defaultTheme.js
// module id = 328
// module chunks = 2